app.mediator.registerModule(MODULE_NAME__NEWSLETTER_CTA, function (app) {

    var helpers = app.helpers.funcs;
    var modalCloseText = 'Close';

    var NewsletterModule = function ($rootElem) {

        var scope = this;

        this.$rootElem = $rootElem;
        this.subscribeUrl = helpers.url('umbraco/api/newsletterapi/signup');

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        this.init = function () {
            this.addDomListeners();
        };

        this.addDomListeners = function () {
            scope.$rootElem.find('.action-newsletter-subscribe').click(function (e) {
                e.preventDefault();
                var email = scope.getEmailValue();
                var territoryCode = scope.getTerritoryCode();
                var languageCode = scope.getLanguageCode();
                var cultureCode = scope.getCultureCode();
                scope.subscribeEmailToNewsletterThenModalAndClear(email, territoryCode, languageCode, cultureCode);
            });
            var $input = scope.$rootElem.find('input[type=email]');
            var oldValue = $input.val();
            scope.$rootElem.find('input[type=email]').keyup(function (e) {
                var ignoreKeys = [27, 13];
                if ($.inArray(e.which, ignoreKeys) < 0 && oldValue !== $(this).val()) {
                    scope.resetErrorMessages();
                    oldValue = $(this).val();
                }
            });
        };

        //==========================================================xdiv2====
        // Module
        //===================================================================

        this.getEmailValue = function () {
            return scope.$rootElem.find('input[type=email]').val();
        };

        this.getTerritoryCode = function () {
            var territoryCode = scope.$rootElem.find('input[type=email]').data('territorycode');
            return territoryCode;
        };

        this.getLanguageCode = function () {
            var languageCode = scope.$rootElem.find('input[type=email]').data('languagecode');
            return languageCode;
        };

        this.getCultureCode = function () {
            var cultureCode = scope.$rootElem.find('input[type=email]').data('culturecode');
            return cultureCode;
        };

        this.resetErrorMessages = function () {
            var errorClass = 'state-danger';
            var $inputElem = scope.$rootElem.find('input[type=email]');
            var $labelElem = scope.$rootElem.find('#newsletter-subscribe-email-label');
            var $holderElem = scope.$rootElem.find('.newsletter-sign-up-error-holder');
            $inputElem.removeClass(errorClass).removeAttr('data-error-code');
            $labelElem.removeClass(errorClass);
            $holderElem.removeClass('active');
        };

        this.subscribeEmailToNewsletterThenModalAndClear = function (email, territoryCode, languageCode, cultureCode) {

            var modal = app.ui.uiPlugins.modal;
            var errorClass = 'state-danger';
            var $inputElem = scope.$rootElem.find('input[type=email]');
            var $labelElem = scope.$rootElem.find('#newsletter-subscribe-email-label');
            var $holderElem = scope.$rootElem.find('.newsletter-sign-up-error-holder');
            var $buttonElem = scope.$rootElem.find('.btn');

            this.resetErrorMessages();
            app.helpers.funcs.loadifyButtons($buttonElem, true);

            scope.subscribeEmailToNewsletter(email, territoryCode, languageCode, cultureCode, function (errorCode, message) {

                if (errorCode !== 21000) {
                    // Add error class and id
                    $inputElem.addClass(errorClass);
                    $inputElem.attr('data-error-code', errorCode);
                    $labelElem.addClass(errorClass);
                    // Show inline input box error
                    var templater = new app.validator.Templater();
                    var messageHtml = templater.contextMessage(message, 'danger', true);
                    $holderElem.html(messageHtml);
                    $holderElem.addClass('active');
                } else {
                    // Add id and reset input
                    modal.setIdAttribute('newsletter-signup-success');
                    $inputElem.val('');
                    // Show modal if NO error code.
                    scope.resetErrorMessages();
                    modal.setCloseButtonText(modalCloseText);
                    modal.clearAdditionalModalClasses();
                    modal.setTitle(scope.getModalTitle());
                    modal.setBodyHtml('<p>' + message + '</p>');
                    modal.show();
                }

                // Deloadify buttons
                app.helpers.funcs.deloadifyButtons($buttonElem, true);
            });
        },

        this.subscribeEmailToNewsletter = function (email, territoryCode, languageCode, cultureCode, callback) {
            callback = typeof callback === 'function' ? callback : function () { };
            if (!email) {
                callback(scope.getNoEmailAddressCode(), scope.getNoEmailAddressMessage());
                return;
            }

            $.ajax({
                type: "POST",
                url: scope.subscribeUrl,
                dataType: 'json',
                data: {
                    emailAddress: email,
                    territoryCode: territoryCode,
                    languageCode: languageCode,
                    cultureCode: cultureCode
                },
                success: function (response) {
                    var errorCode = helpers.arrayGet(response, 'notifications.0.code', false);
                    var message = helpers.arrayGet(response, 'notifications.0.message', false);
                    if (errorCode) {
                        callback(errorCode, message);
                    } else {
                        callback(false, scope.getSuccessMessage());
                    }
                },
                error: function (response, status, err) {
                    callback(scope.getGeneralSignupErrorCode(), scope.getGeneralSignupErrorMessage());
                }
            });
        };

        this.getHelperTemplateHtmlObject = function () {
            var itemInner = helpers.getTemplateHtml($('#subscribe-section-template').get(0)).querySelectorAll('.template-inner');
            return $templateHtml = $(itemInner);
        };

        this.getNoEmailAddressMessage = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return $templateHtml.find('#subscribe-template-no-email-message').text();
        };

        this.getNoEmailAddressCode = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return parseInt($templateHtml.find('#subscribe-template-no-email-code').text());
        };

        this.getInvalidEmailAddressCode = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return parseInt($templateHtml.find('#subscribe-template-invalid-email-code').text());
        }

        this.getGeneralSignupErrorMessage = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return $templateHtml.find('#subscribe-template-general-error-message').text();
        };

        this.getGeneralSignupErrorCode = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return parseInt($templateHtml.find('#subscribe-template-general-error-code').text());
        };

        this.getSuccessMessage = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return $templateHtml.find('#subscribe-template-success-message').text();
        };

        this.getModalTitle = function () {
            var $templateHtml = scope.getHelperTemplateHtmlObject();
            return $templateHtml.find('#subscribe-template-modal-title').text();
        };
    };

    return {

        setCloseButtonText: function (text) {
            modalCloseText = text;
        },

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        // This pattern of initialising allows us to have multiple instances of the module
        // appear on the same page.
        init: function () {
            $elems = $('.mod-newsletter-cta');
            if (!$elems.length) return;
            $elems.each(function (k, elem) {
                var $elem = $(elem);
                var module = new NewsletterModule($elem);
                module.init();
            });
        }

    };
});
